import { Box, Button, IconButton, Skeleton, Switch, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { DataGrid, } from '@mui/x-data-grid';
import { PermissionGuard } from '../../../components/PermissionGuard';
import PageHeaderLayout from '../../../components/Layout/PageHeaderLayout';
import { useNavigate } from 'react-router-dom';
import { ArrowBack, Cancel, CheckCircle, ContentCopy, Edit } from '@mui/icons-material';
import { CouponServices } from './CouponServices';
import { useForm } from 'react-hook-form';
import Loading from '../../../components/Loader/Loading';
import { formatDateTime } from '../../../utils/dateUtils';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import QuickSearchTool from '../../../components/QuickSearch/QuickSearchTool';
import NoRowsLayout from '../../../components/Layout/NoRowsLayout';
import useResponsive from '../../../hooks/useResponsive';
import Swal from 'sweetalert2';
import ExportAll from './ExportAll';
import isExpired from '../../../utils/checkCouponExpiry';

const SystemCoupons = () => {
  const { isSm } = useResponsive();
  const navigate = useNavigate();
  const { control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({
    mode: "onChange"
  });
  const [allRowCount, setAllRowCount] = useState(0);
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 50,
    filters: {
      searchKey: "",
      sortBy: 'createdAt',
      sortType: 'desc',
      filterOptions: [
        {
          "fieldName": "generatedBy",
          "operator": "equals",
          "value": "system"
        }
      ]
    }
  });
  const [loading, setLoading] = useState(false);
  const fetchCouponList = async () => {
    try {
      setLoading(true)
      const listResponse = await CouponServices.couponList({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortBy: paginationModel.filters.sortBy,
          sortType: paginationModel.filters.sortType,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      console.log("Banner list Response:", listResponse)
      setValue('status', paginationModel.filters.status)
      if (listResponse.success == '1') {
        setList(listResponse.data.coupons);
        setAllRowCount(listResponse.data.totalItems);
      }
      else {
        //   Swal.fire('Request failed','','error')
      }
    } catch (error) {
      Swal.fire(error.message, '', 'error')
    }
    setLoading(false)
  };

  /************************  Manage Use Effect **************************** */
  useEffect(() => {
    fetchCouponList();
  }, [paginationModel]);

  const [copied, setCopied] = useState(0);
  
  
  /************************  Table Column Manage **************************** */
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      headerAlign: 'center',
      flex: 0.5,
      filterable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, textAlign: 'center', width: '100%' }}>
          <Typography variant="body2" sx={{ fontSize: '.65rem' }}>{params.row.id}</Typography>
        </Box>
      ),
    },
    {
      field: 'couponCode',
      headerName: 'Coupon Code',
      headerAlign: 'center', sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100,
      sortable: false,
      // valueGetter: (params) => {
      //   return params.row?.platforms.map(platform => platform).join(', ');
      // },
      renderCell: (params) => {
        const handleCopy = () => {
          if (params.row?.couponCode) {
              navigator.clipboard.writeText(params.row?.couponCode);
              setCopied(params.row.id);
              setTimeout(() => setCopied(0), 2000); // Reset after 2 seconds
          }
      };
        return (
          <Box sx={{ width: '100%', textAlign: 'center',display:'flex',alignItems:"center",justifyContent:'center' }}>
            <Typography sx={{ fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem' }}>{params.row?.couponCode}</Typography>
            <Tooltip title={copied==params.row.id ? "Copied!" : "Copy Code"}>
              <IconButton size="small" onClick={handleCopy} sx={{color:copied==params.row.id ?'green':'blue'}}>
                  {copied==params.row.id ?
                  
                    <CheckCircle  fontSize="x-small" />
                    :
                    <ContentCopy fontSize="x-small" />
                  }
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },

    {
      field: 'displayPeriod',
      headerName: 'Offer Period',
      headerAlign: 'center',
      flex: 1.1,
      minWidth: 150,
      filterable: false,
      sortable: false,
      valueGetter: (params) => {
        const startDate = params.row.startDate ? formatDateTime(params.row.startDate, 'date') : 'N/A';
        const endDate = params.row.endDate ? formatDateTime(params.row.endDate, 'date') : 'N/A';
        return `${startDate} to ${endDate}`;
        // return `${formatDateTime(params.row.issueDate,'date')} to ${formatDateTime(params.row.endDate,'date')}`;
      },
      renderCell: (params) => {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography sx={{ fontSize: '0.5rem' }}> <Box component={'span'} sx={{ fontWeight: 600 }}>Start Date: </Box>{params.row.startDate ? formatDateTime(params.row.startDate,'date') : 'N/A'}</Typography>
            <Typography sx={{ fontSize: '0.5rem' }}> <Box component={'span'} sx={{ fontWeight: 600 }}>Expiry Date: </Box>{params.row.endDate ? formatDateTime(params.row.endDate,'date') : 'N/A'}</Typography>
          </Box>
        )
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      headerAlign: 'center',
      flex: .5,
      sortable: false,
      valueGetter: (params) => {
        
        
        const expired = isExpired(params.row.endDate);
        return expired? 'expired':params.row.status ? 'Active' : 'In-Active';
      },
      renderCell: (params) => {
        
        const expired = isExpired(params.row.endDate);
        
        return (
          <PermissionGuard feature='banner' permission='canEdit'>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center', width: '100%' }}>
              <Switch
                // disabled if expired
                disabled={expired}
                size='small'
                checked={params.row.status}
                onChange={() => handleStatusChange({ status: params.row.status ? 'inactive' : 'active' }, params.row.id)}
                sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                    color: 'success.main',
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: 'success.main'
                  },
                  '& .MuiSwitch-switchBase': {
                    color: 'error.main',
                  },
                  '& .MuiSwitch-track': {
                    backgroundColor: 'error.main'
                  }
                }}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              {expired ?
                <Typography variant="body2" sx={{ color: 'error.main', fontSize: '.65rem' }}>Expired</Typography>
                :
                <Typography
                  variant="body2"
                  size="small"
                  sx={{
                    color: params.row?.status ? 'success.main' : 'error.main',
                    fontWeight: '600',
                    fontSize: '.65rem'
                  }}
                >
                  {params.row?.status ? 'Active' : 'In-Active'}
                </Typography>
              }
            </Box>
          </PermissionGuard>
        )
      },
    },
    {
      field: 'details',
      headerName: 'Details',
      headerAlign: 'center',
      flex: 1.75,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box sx={{ width: '100%' }}>
            <Box sx={{ py:'2%',display: 'flex', gap: 1, alignItems: 'center',borderBottom:'1px solid lightgrey' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem', color: '#3e3e3e' }}>User Specific</Typography>
              <Typography sx={{ fontWeight: 500, color: '#3e3e3e', fontSize: '0.65rem' }}>:</Typography>
              {/* <Typography sx={{ fontWeight: 400, color: '#3e3e3e', fontSize: '0.65rem' }}>{params.row.title || 'N/A'}</Typography> */}
              <IconButton size='small' sx={{ p: 0 }}>{params.row?.selectedCustomers.length > 0 ? <CheckCircle color='success' sx={{ fontSize: '0.65rem' }} /> : <Cancel color='error' sx={{ fontSize: '0.65rem' }} />}</IconButton>
            </Box>
            <Box sx={{ py:'2%',display: 'flex', gap: 1, alignItems: 'center',borderBottom:'1px solid lightgrey' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem',color: '#3e3e3e' }}>Limit Per User</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: '0.5rem',color: '#3e3e3e' }}>:</Typography>
              <Typography sx={{ fontWeight: 400, fontSize: '0.5rem',color: '#3e3e3e',textTransform:'capitalize' }}>{params.row.limitPerUser || 'N/A'}</Typography>
            </Box>
            <Box sx={{ py:'2%',display: 'flex', gap: 1, alignItems: 'center',borderBottom:'1px solid lightgrey' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem',color: '#3e3e3e' }}>Coupon Type</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: '0.5rem',color: '#3e3e3e' }}>:</Typography>
              <Typography sx={{ fontWeight: 400, fontSize: '0.5rem',color: '#3e3e3e',textTransform:'capitalize' }}>{params.row.couponType || 'N/A'}</Typography>
            </Box>
            <Box sx={{ py:'2%',display: 'flex', gap: 1, alignItems: 'center',borderBottom:'1px solid lightgrey' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem',color: '#3e3e3e' }}>Coupon Value</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: '0.5rem',color: '#3e3e3e' }}>:</Typography>
              <Typography sx={{ fontWeight: 400, fontSize: '0.5rem',color: '#3e3e3e' }}>{params.row.couponValue}%</Typography>
            </Box>
            <Box sx={{ py:'2%',display: 'flex', gap: 1, alignItems: 'center',borderBottom:'1px solid lightgrey' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem',color: '#3e3e3e' }}>Min. Booking Amt.</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: '0.5rem',color: '#3e3e3e' }}>:</Typography>
              <Typography sx={{ fontWeight: 400, fontSize: '0.5rem',color: '#3e3e3e' }}>₹{params.row.minimumBookingAmt}</Typography>
            </Box>
            <Box sx={{  py:'2%',display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography sx={{ width: '45%', fontWeight: 600, fontSize: '0.5rem',color: '#3e3e3e' }}>Max. Disount Amt.</Typography>
              <Typography sx={{ fontWeight: 500, fontSize: '0.5rem',color: '#3e3e3e' }}>:</Typography>
              <Typography sx={{ fontWeight: 400, fontSize: '0.5rem',color: '#3e3e3e' }}>₹{params.row.maximumDiscount}</Typography>
            </Box>

          </Box>
        );
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      headerAlign: 'center',
      flex: 1.5,
      minWidth: 200,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1,width:'100%'}}>
          <Typography sx={{ fontWeight: 400, color: '#3e3e3e', fontSize: '0.5rem' }}>
            <Box component={'span'} sx={{fontWeight: 600, fontSize: '0.65rem',color: '#3e3e3e',mr:1 }}>
                Title :
            </Box>
             {params.row.title || 'N/A'}
          </Typography>
          <Typography variant="body2" sx={{ fontSize: '.5rem' }}>
            <Box component={'span'} sx={{fontWeight: 600, fontSize: '0.65rem',color: '#3e3e3e',mr:1 }}>
              Desc.:
            </Box>
            {params.row.description}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'createdAt',
      headerName: 'Created On',
      headerAlign: 'center',
      flex: 1,
      filterable: false,
      sortingOrder: ['asc', 'desc'],
      valueGetter: (params) => {
        return params.row.createdAt ? formatDateTime(params.row.createdAt) : '';
      },
      renderCell: (params) => {
        return (
          <Typography sx={{ fontSize: '0.55rem' }}>{params.row.createdAt ? formatDateTime(params.row.createdAt) : ''}</Typography>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign: 'center',
      flex: .5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, display: 'flex', gap: 1, justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
          <IconButton
            sx={{ color: "blue", }}
            onClick={() => window.open(`/marketing/coupon/view/${params.row.id}`, '_blank')}
            size="small">
            <RemoveRedEyeIcon sx={{ fontSize: '0.95rem' }} />
          </IconButton>
          {isExpired(params.row.endDate) ? null :
            <PermissionGuard feature='coupon' permission='canEdit'>
              <IconButton onClick={() => navigate(`/marketing/coupon/${params.row.id}`)} size="small" color='warning'>
                <Edit sx={{ fontSize: '0.95rem' }} />
              </IconButton>
            </PermissionGuard>}
          {/* <IconButton onClick={() => deleteService(params.row.id)} size="small">
            <DeleteIcon />
          </IconButton> */}
        </Box>
      ),
    },
  ];

  const handleStatusChange = async (data, couponId) => {
    // console.log ("required customer data for status change:",data);
    const result = await Swal.fire({
      text: "Do you want to Change Coupon Status now?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Change now!',
      cancelButtonText: 'No, Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
    });

    if (result.isConfirmed) {
      try {
        // Show loading state
        Swal.fire({
          title: 'Processing...',
          text: `Please wait while we update the banner status from ${data.status ? 'active' : 'inactive'} to ${data.status ? 'inactive' : 'active'}`,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Make the API call
        const statusChangeResponse = await CouponServices.changeStatus(couponId);
        // console.log("customer account status change response:", statusChangeResponse);

        // Close loading dialog and show success/error message
        if (statusChangeResponse.success == '1') {
          await fetchCouponList();
          await Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: statusChangeResponse.message || 'Banner Status updated successfully',
            timer: 1500
          });

          return true;
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: statusChangeResponse.message || 'Failed to update banner status'
          });
          return false;
        }

      } catch (error) {
        // console.error("Error changing customer account status:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'An error occurred while updating the banner status'
        });
        return false;
      }
    } else {
      return false;
    }
  };

  /************************  Action Handler Related table row **************************** */
  const handlePaginationChange = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /************************  Advance Filter **************************** */


  const [clearMultiFilter, setClearMultiFilter] = useState(false);
  const filterableColumns = [
    {
      key: 'couponCode',
      label: 'Coupon Code',
      type: 'text'
    },
    {
      key: 'couponType',
      label: 'CouponType',
      type: 'select',
      options: [
        { value: 'fixed', label: 'Fixed' },
        { value: 'percentage', label: 'Percentage' }
      ]
    },
    {
      key: 'generatedBy',
      label: 'Generated By',
      type: 'select',
      options: [
        // { value: 'manual', label: 'Manual' },
        { value: 'system', label: 'System' }
      ]
    },
    {
      key: 'isExpired',
      label: 'Is Expired',
      type: 'select',
      options: [
        { value: 'true', label: 'expired' },
        { value: 'false', label: 'not-expired' }
      ]
    },
    {
      key: 'startDate',
      label: 'Start Date',
      type: 'date'
    },
    {
      key: 'endDate',
      label: 'Expiry Date',
      type: 'date'
    },
    {
      key: 'createdAt',
      label: 'Created Date',
      type: 'date'
    }
  ];
  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
        filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  /************* quick search related **************/
  // Properly structured filter model
  const [filterModel, setFilterModel] = useState({
    items: [],
    quickFilterValues: []
  });

  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortBy,
      sort: paginationModel.filters.sortType,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortBy: newSortModel[0].field,
          sortType: newSortModel[0].sort
        }
      }));
    }
    // else{
    //   setSortModel([{
    //     field: 'createdAt',
    //     sort: 'asc',
    //   }]);
    //   setPaginationModel(prev => ({
    //     ...prev,
    //     filters: {
    //       ...prev.filters,
    //       sortBy: 'createdAt',
    //       sortType: 'asc'
    //     }
    //   }));
    // }
  }
  return (
    <Box>
      {/* ===========page title================= */}
      
      <Box sx={{ overflow: "auto" }}>
        {loading && <Loading />}
        <Box sx={{ width: "100%", display: "table", tableLayout: "fixed", backgroundColor: "#fff", borderRadius: '.5rem' }}>
          <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <MultiColumnFilter
                    filterableColumns={filterableColumns}
                    onApplyFilter={handleApplyFilter}
                    externalClear={clearMultiFilter}
                    defaultFilterOptions= {[{
                        "fieldName": "generatedBy",
                        "operator": "equals",
                        "value": "system"
                      }]}
                    alwaysKeepDefaultFilterOption={true}
                  />
              <ExportAll
                paginationModel={paginationModel} 
                // columns={columns} 
                // statusOptions={statusOptions} 
              />
            </Box>

            <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} />
          </Box>
          <DataGrid
            rows={list}
            columns={columns.map((col) => ({
              ...col,
              // flex: col.flex || 1, // Ensure columns resize dynamically
              minWidth: isSm && (col.minWidth || 100), // Set a minimum width to avoid overlap
            }))}
            getRowId={(row) => row.id}
            //checkboxSelection={true}
            rowCount={allRowCount}  // Use the length of the filtered list
            pageSizeOptions={[5, 10, 20, 50, 100]}
            paginationModel={paginationModel}
            paginationMode="server"
            onPaginationModelChange={handlePaginationChange}

            filterModel={filterModel}

            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortingChange}
            disableMultiSort={true}

            loading={loading}

            disableColumnMenu
            disableRowSelectionOnClick
            slots={{
              // toolbar: GridToolbar,                        
              loadingOverlay: Loading,
              noRowsOverlay: NoRowsLayout,
            }}
            autoHeight
            getRowHeight={() => 'auto'}
            sx={{
              '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                borderBottom: '2px solid rgba(224, 224, 224, 1)',
                borderTop: '2px solid rgba(224, 224, 224, 1)',
                fontWeight: 600,
                fontSize: '0.75rem',
                p: 0,
                height: 'fit-content',
                minHeight: '0 !important',
                height: '2rem'
              },
              '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
              },
              '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                  borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                  borderRight: 'none',
                },
              },
              '& .MuiDataGrid-columnSeparator': {
                display: 'none',
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default SystemCoupons;
